<template>
  <v-card>
    <v-card-title primary-title>
      Documents
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="stockItemFiles"
      >
        <template v-slot:item.created="{ item }">
          {{ formatDateTime(item.created) }}
        </template>
        <template v-slot:item.fileUrl="{ item }">
          <a :href="item.fileUrl">{{ item.fileName }}</a>
        </template>
      </v-data-table>
    </v-card-text>
    <v-form
      lazy-validation
      v-model="valid"
      @submit.prevent="submit"
      ref="form"
    >
        <v-container class="text-center">
          <v-text-field
            filled
            data-cy="FormEvidenceItem-name"
            :label="$$t('name')"
            v-model="localFile.name"
          />
          <ImageUpload
            accept="*"
            @input="fileUploadCompleted"
            data-cy="FormEvidenceItem-file-image-upload"
            v-model="localFile.file"
            :label="$$t('file')" />
          <v-row v-if="fileUploaded">
            <v-col cols="12">
              <v-icon>
                mdi-check
              </v-icon>
              File Uploaded
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" color="error">
              <v-icon>
                mdi-cancel
              </v-icon>
              No file uploaded yet
            </v-col>
          </v-row>
          <div class="d-flex justify-end mb-6">
            <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
              data-cy="FormEvidenceItem-button-close">
              {{ $t('common.buttons.close') }}
            </v-btn>
          </div>
        </v-container>
    </v-form>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'StockItemFiles',
  module: 'StockItem',
  mixins: [loading],
  data() {
    return {
      stockItemId: this.$route.query.stockItemId,
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localFile
      */
      localFile: {
        stockItemId: this.$route.query.stockItemId,
      },
    };
  },
  computed: {
    ...mapState('stockItemFiles', ['stockItemFiles']),
    fileUploaded() {
      return this.localFile.file?.length > 0;
    },
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('fileUrl'),
          value: 'fileUrl',
        },
        {
          text: this.$$t('created'),
          value: 'created',
        },
        {
          text: this.$$t('createdBy'),
          value: 'createdBy',
        },
      ];
    },
  },
  watch: {
    fileUploaded() {
      console.log(this.localFile);
    },
  },
  async mounted() {
    await this.LOAD_stockItemFiles(this.stockItemId);
  },
  created() {
    this.localFile = {};
  },
  methods: {
    ...mapActions('stockItemFiles', ['CREATE_stockItemFile', 'LOAD_stockItemFiles']),
    async fileUploadCompleted(file) {
      await this.CREATE_stockItemFile({
        fileUrl: file,
        stockItemId: this.stockItemId,
        fileName: this.localFile.name,
      });
      await this.LOAD_stockItemFiles(this.stockItemId);
    },
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localFile);
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
      this.$router.push({ name: 'processing-ListFactoryItem' });
    },
  },
};
</script>
